module.exports = __webpack_public_path__ + "static/media/code_thinking.9521dc9b.svg";